import { ThemeSchema } from "../theme";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const draycirFavIcons = [
  {
    id: "fave-icon",
    src: "/favicon/syspro-favicon-32x32.png",
  },
  {
    id: "apple-touch-icon",
    src: "/favicon/syspro-favicon-apple.png",
  },
];

const favIcons = [
  {
    id: "fave-icon",
    src: "/favicon/syspro-favicon-32x32.png",
  },
  {
    id: "fave-icon-32x32",
    src: "/favicon/syspro-favicon-32x32.png",
  },
  {
    id: "fave-icon-192x192",
    src: "/favicon/syspro-favicon-apple.png",
  },
  {
    id: "fave-icon-apple",
    src: "/favicon/syspro-favicon-apple.png",
  },
];

// eslint-disable-next-line import/prefer-default-export
export const sysproTheme: ThemeSchema = {
  id: "syspro",
  footerLogo: "paythem-footer-syspro.svg",
  spinners: {
    expanding: "draycir-spinner-expand-syspro.json",
    shrinking: "draycir-spinner-shrink-syspro.json",
  },
  favIcons,
};
